import { createReducer, on } from '@ngrx/store'
import { setNotifications, unauthorizedUser } from '@adex/store/actions'
import { notificationsEntityAdapter } from '@adex/store/adapters'


const initialState = notificationsEntityAdapter.getInitialState()

export const notificationsEntityReducer = createReducer(
  initialState,
  on(unauthorizedUser, () => ({ ...initialState })),
  on(setNotifications, (state, { data }) => notificationsEntityAdapter.setAll(data, state))
)
